import {createContext} from 'react';
import {
    AuthUser,
    JWT
} from 'aws-amplify/auth';
import {AuthStatus} from '@flexinet/auth-components';


export type AuthContextType = {
    user: AuthUser | undefined,
    idToken?: JWT | undefined,
    accessToken?: JWT | undefined,
    cognitoGroups?: string[] | undefined,
    role?: string | undefined,
    // FNP-1731: 'resolving' until both the user and the session lookups settle.
    status: AuthStatus,
}


export const AuthContext = createContext<AuthContextType>({
                                                              user: {} as AuthUser,
                                                              status: 'resolving',
                                                          });
